module.exports = __webpack_public_path__ + "img/step-img3.943a32c4.png";